import React, { useContext } from 'react';
import { Dialog, DialogContent, DialogTitle, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import { Pathname } from 'Routes';
import { AppContext } from 'Context';
import styles from './PermissionDeniedModal.module.css';

export const PermissionDeniedModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { langText } = useContext(AppContext);
  const commonText = langText?.common;

  const handleUpgradeClick = () => {
    navigate('/switchplan');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        className: styles.dialogPaper
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(12px)',
        }
      }}
    >
      <DialogTitle className={styles.dialogTitle}>
        <div className={styles.iconWrapper}>
          <LockIcon className={styles.lockIcon} />
        </div>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <h2 className={styles.title}>
          {commonText?.permissionDenied || 'Permission Denied'}
        </h2>
        <p className={styles.message}>
          {commonText?.upgradeToAccess || 'You need to upgrade your plan to access this video content.'}
        </p>
        <p className={styles.subMessage}>
          {commonText?.upgradeMessage || 'Upgrade now to unlock unlimited videos and premium features.'}
        </p>
        <div className={styles.buttonGroup}>
          <Button
            onClick={handleUpgradeClick}
            className={styles.upgradeButton}
            variant="contained"
            color="primary"
          >
            {commonText?.upgradePlan || 'Upgrade Plan'}
          </Button>
          <Button
            onClick={onClose}
            className={styles.cancelButton}
            variant="outlined"
          >
            {commonText?.cancel || 'Cancel'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PermissionDeniedModal;
